import { useEffect, useState } from "react";
import { createDiscounts} from "../services/AllServices";
import { downloadCSV, showMessage } from "../utils/helpers";
import { useNavigate } from "react-router-dom";

const useDiscountViewController = () => {

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const [loading, setLoading] = useState(false);
    const [saveStatus, setSaveStatus] = useState(true);
    const role = localStorage.getItem("role");
    const navigate = useNavigate();

    const uploadFile = async () => {
        setLoading(true);
        try {
            const formData = new FormData();
            formData.append("item_discounts_csv", selectedFile);
            let responseData = await createDiscounts(formData);
            if (responseData) {
                showMessage("success", "Discounts list have been added successfully");
                setSaveStatus(true);
                goBack();
            } else {
                showMessage("error", responseData?.detail || "Something went wrong");
            }
        } catch (error) {
            showMessage("error", error?.data.message || "Something went wrong");
        }
        setSelectedFile(null);
        setFileName("");
        setLoading(false);
    };

    const downloadSampleCSV = () => {
        downloadCSV(process.env.PUBLIC_URL + "/DiscountSample.csv","Discount Sample.csv");
    };

    useEffect(() => {
        if (selectedFile) {
            setSaveStatus(false);
        } else {
            setSaveStatus(true);
        }
    }, [selectedFile]);

    const goBack = () => {
        if (role === "admin") {
            navigate('/home');
        }
        else {
            navigate('/request-management');
        }
    }


    return {
        goBack,
        downloadSampleCSV,
        setSelectedFile,
        saveStatus,
        fileName,
        setFileName,
        uploadFile,
        selectedFile,
        loading
    };
};

export default useDiscountViewController;